<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <button :class="b('', { active: value })" @click="handleSwitch">
    <span :class="b('circle', { active: value })"></span>
  </button>
</template>
